module.exports = __webpack_public_path__ + "static/media/pre2.ebdca9d2.jpg";